import React, { useEffect, useRef, useState } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { Dropdown, Modal } from "react-bootstrap";
import MainPagetitle from "../../../layouts/MainPagetitle";
import LoanApplicationSearch from "./LoanApplicationSearch/LoanApplicationSearch";
import { store } from "../../../../utils/redux/store";
import LeadsCenteredModal from "../Leads/LeadsCenteredModal";

const LoanApplications = (props) => {
  const userRole = props?.$store?.persona;
  const isAdmin = props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
  const isCpa = props?.$store?.persona === _enum.ROUTE_PERSONAS.cpa;
  const isUnderWriter =
    props?.$store?.persona === _enum.ROUTE_PERSONAS.underwriter;
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [rowcount, setRowcount] = useState(0);
  const pendingapplicationsColumns = [
    {
      dataIndex: "customer",
      title: "Name",
      render: (text, record) => {
        return (
          <div>
            <h6 className="text-primary">{record?.customerName}</h6>
            <span>{record?.applicationId}</span>
          </div>
        );
      },
    },
    {
      dataIndex: "applicationAddressInfo",
      title: "Location",
      render: (text, record) => {
        return (
          <>
            {record?.applicationAddressInfo?.filter(
              (v) => v?.addressType === "COMMUNICATION"
            )[0]?.city || "-"}
          </>
        );
      },
    },
    {
      dataIndex: "mobileNumber",
      title: "Mobile No.",
      render: (text, record) => {
        return record?.customer?.mobileNumber;
      },
    },
    {
      dataIndex: "createdAt",
      title: "Application Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    {
      dataIndex: "applicationType",
      title: "Application Type",
      render: (text, record) => {
        return <>{record?.customerApplicationType?.toTitleCase() || "-"}</>;
      },
    },
    {
      dataIndex: "appliedDevice",
      title: "Platform",
      render: (text) => {
        return <>{text || "-"}</>;
      },
    },
    {
      dataIndex: "loanAmount",
      title: "Applied Loan Amount",
      render: (text) => {
        return <>{text?.cur()}</>;
      },
    },
    {
      dataIndex: "duration",
      title: "Tenure",
      render: (text, record) => {
        return <span>{text ? `${text} Days` : "N/A"}</span>;
      },
    },
    {
      dataIndex: "status",
      title: "Application Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.status?.toLowerCase()] || "";
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record.status.toTitleCase()}</span>
              <i class="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];
  const rejectedapplicationsColumns = [
    {
      dataIndex: "customer",
      title: "Name",
      render: (text, record) => {
        return (
          <div>
            <h6 className="text-primary">{text?.customerName}</h6>
            <span>{record?.applicationId}</span>
          </div>
        );
      },
    },
    {
      dataIndex: "underwriter",
      title: "Underwriter",
      render: (text, record) => {
        return <>{record?.underwriter?.name || "-"}</>;
      },
    },
    {
      dataIndex: "applicationAddressInfo",
      title: "Location",
      render: (text, record) => {
        return (
          <>
            {record?.applicationAddressInfo?.filter(
              (v) => v?.addressType === "COMMUNICATION"
            )[0]?.city || "-"}
          </>
        );
      },
    },
    {
      dataIndex: "mobileNumber",
      title: "Mobile No.",
      render: (text, record) => {
        return record?.customer?.mobileNumber;
      },
    },
    {
      dataIndex: "createdAt",
      title: "Application Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    {
      dataIndex: "applicationType",
      title: "Application Type",
    },
    {
      dataIndex: "appliedDevice",
      title: "Platform",
      render: (text) => {
        return <>{text || "-"}</>;
      },
    },
    {
      dataIndex: "loanAmount",
      title: "Applied Loan Amount",
      render: (text) => {
        return <>{text?.cur()}</>;
      },
    },
    {
      dataIndex: "duration",
      title: "Tenure",
      render: (text, record) => {
        return <span>{text ? `${text} Days` : "N/A"}</span>;
      },
    },
    {
      dataIndex: "rejectedReason",
      title: "Remarks",
      render: (text, record) => {
        return <span>{text?.toTitleCase() || "-"}</span>;
      },
    },
    {
      dataIndex: "status",
      title: "Application Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.status?.toLowerCase()] || "";
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record.status.toTitleCase()}</span>
              <i class="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];
  const inprogressColumns = [
    {
      dataIndex: "customer",
      title: "Name",
      render: (text, record) => {
        return (
          <div>
            <h6 className="text-primary">{text?.customerName}</h6>
            <span>{record?.applicationId}</span>
          </div>
        );
      },
    },
    {
      dataIndex: "customer",
      title: "Customer Type",
      render: (text, record) => {
        return (
          <div>
            <h6>{record?.customerApplicationType?.toTitleCase() || "-"}</h6>
          </div>
        );
      },
    },
    {
      dataIndex: "underwriter",
      title: "Underwriter",
      render: (text, record) => {
        return <>{record?.underwriter?.name || "-"}</>;
      },
    },
    {
      dataIndex: "applicationAddressInfo",
      title: "Location",
      render: (text, record) => {
        return (
          <>
            {record?.applicationAddressInfo?.filter(
              (v) => v?.addressType === "COMMUNICATION"
            )[0]?.city || "-"}
          </>
        );
      },
    },
    {
      dataIndex: "mobileNumber",
      title: "Mobile No.",
      render: (text, record) => {
        return record?.customer?.mobileNumber;
      },
    },
    {
      dataIndex: "createdAt",
      title: "Application Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    // {
    //   dataIndex: "applicationType",
    //   title: "Application Type",
    // },
    // {
    //   dataIndex: "appliedDevice",
    //   title: "Platform",
    //   render: (text) => {
    //     return <>{text || "-"}</>;
    //   },
    // },
    {
      dataIndex: "loanAmount",
      title: "Applied Loan Amount",
      render: (text) => {
        return <>{text?.cur()}</>;
      },
    },
    {
      dataIndex: "duration",
      title: "Applied Tenure",
      render: (text) => {
        return <>{text} Days</>;
      },
    },
    {
      dataIndex: "status",
      title: "Application Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.status?.toLowerCase()] || "";
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record.status.toTitleCase()}</span>
              <i class="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];
  const sanctionedColumns = [
    {
      dataIndex: "customer",
      title: "Name",
      render: (text, record) => {
        return (
          <div>
            <h6 className="text-primary">{record?.customerName}</h6>
            <span>{record?.applicationId}</span>
          </div>
        );
      },
    },
    {
      dataIndex: "underwriter",
      title: "Underwriter",
      render: (text, record) => {
        return <>{record?.underwriter?.name || "-"}</>;
      },
    },
    {
      dataIndex: "applicationAddressInfo",
      title: "Location",
      render: (text, record) => {
        return (
          <>
            {record?.applicationAddressInfo?.filter(
              (v) => v?.addressType === "COMMUNICATION"
            )[0]?.city || "-"}
          </>
        );
      },
    },
    {
      dataIndex: "mobileNumber",
      title: "Mobile No.",
      render: (text, record) => {
        return record?.customer?.mobileNumber || "-";
      },
    },
    {
      dataIndex: "createdAt",
      title: "Application Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    // {
    //   dataIndex: "applicationType",
    //   title: "Application Type",
    // },
    // {
    //   dataIndex: "appliedDevice",
    //   title: "Platform",
    //   render: (text) => {
    //     return <>{text || "-"}</>;
    //   },
    // },
    // {
    //   dataIndex: "loanAmount",
    //   title: "Applied Loan Amount",
    //   render: (text) => {
    //     return <>{text?.cur()}</>;
    //   },
    // },
    {
      dataIndex: "sanctionedLoanAmt",
      title: "Sanctioned Amount",
      render: (text) => {
        return <>{text?.cur() || "-"}</>;
      },
    },
    {
      dataIndex: "sanctionedIRR",
      title: "ROI",
      render: (text) => {
        return <>{text ? text + " %" : "-"}</>;
      },
    },
    {
      dataIndex: "sanctionedTenure",
      title: "Sanctioned Loan Tenure",
      render: (text, record) => {
        let tenure = record?.sanctionedTenure;
        return <>{tenure ? `${tenure} Days` : "-"}</>;
      },
    },
    {
      dataIndex: "kfs",
      title: "KFS",
      render: (text, record) => {
        return record.status === "ESIGNED" ? (
          <div className="docs_card">
            <a
              href={record?.applicationLoanAccount?.signzyLoanAgreementLink}
              target="_blank"
              className="text-primary text-underline"
            >
              Download
            </a>
          </div>
        ) : (
          <>-</>
        );
      },
    },
    {
      dataIndex: "status",
      title: "Application Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.status?.toLowerCase()] || "";
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record.status.toTitleCase()}</span>
              <i class="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];

  const [columns, setColumns] = useState(inprogressColumns);
  const [activeKey, setActiveKey] = useState("");
  const filterTabData = [
    {
      key: "pendingapplications",
      name: "Pending Applications",
    },
    {
      key: "inprogress",
      name: "In progress",
    },
    {
      key: "sanctioned",
      name: "Sanctioned",
    },
    {
      key: "approved",
      name: "Approved",
    },
    {
      key: "rejected",
      name: "Rejected",
    },
  ];

  const handleSelect = (e, key) => {
    let payload = {
      page: 1,
      limit: 10,
    };
    setSearch(payload);
    setActiveKey(key);
    navigate(`/app/loanapplications?activetab=${key}`);
  };

  const onPageChange = (pageData) => {
    setSearch((prevState) => ({
      ...prevState,
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    }));
  };

  const getUnassignedApplications = (params = {}) => {
    let payload = {
      ...params,
    };
    console.log("getUnassignedApplications: ", payload);
    props.apis
      .apiGetUnderWriterUnassignedApplications(payload)
      .then(({ data, total }) => {
        setTableData(data);
        setIsFetching(false);
        setRowcount(total);
      });
  };

  const getRejectedApplications = (params = {}) => {
    let payload = {
      ...params,
    };

    props.apis
      .apiGetUnderWriterRejectedApplications(payload)
      .then(({ data, total }) => {
        setTableData(data);
        setIsFetching(false);
        setRowcount(total);
      });
  };

  const getApplications = (params = {}) => {
    let payload = {
      ...params,
    };

    props.apis
      .apiGetUnderWriterInprogressApplications(payload)
      .then(({ data, total }) => {
        setTableData(data);
        setIsFetching(false);
        setRowcount(total);
      });
  };

  const getSanctionedApplications = (params = {}) => {
    let payload = {
      ...params,
    };

    props.apis
      .apiGetUnderWriterSanctionedApplications(payload)
      .then(({ data, total }) => {
        setTableData(data);
        setIsFetching(false);
        setRowcount(total);
      });
  };

  const getApprovedApplications = (params = {}) => {
    let payload = {
      ...params,
    };

    props.apis
      .apiGetUnderWriterApprovedApplications(payload)
      .then(({ data, total }) => {
        setTableData(data);
        setIsFetching(false);
        setRowcount(total);
      });
  };

  const view = (record) => {
    console.log({ record });
    let inprogressStatus = ["Under_writing", "Applied", "Query"];
    let sanctionedStatus = [
      "Sanctioned",
      "Post_sanctioned",
      "Customer_Declined",
    ];
    let approvedStatus = [];
    let activestatus = "";
    if (sanctionedStatus.includes(record.status)) {
      activestatus = "sanctioned";
    } else if (inprogressStatus.includes(record.status)) {
      activestatus = "inprogress";
    } else if (approvedStatus.includes(record.status)) {
      activestatus = "approved";
    }

    navigate(
      `/app/loanapplicationsview?id=${record?.applicationId}&status=${activeKey}&frompath=loanapplications&readonly=true`
    );
  };

  const edit = (record) => {
    console.log({ record });
    navigate(
      `/app/loanapplicationsview?id=${record?.applicationId}&frompath=loanapplications&status=${activeKey}&applicationStatus=${record?.status}`
    );
  };

  const softDeleteApplication = (record) => {
    console.log({ record });
    swal2
      .fire({
        title: "Are you sure you want to soft delete this application?",
        icon: "warning",
        iconColor: "#BB1766",
        showCancelButton: true,
        confirmButtonColor: "#BB1766",
        cancelButtonColor: "##D6DBE7",
        confirmButtonText: "Yes, delete it!",
      })
      .then((result) => {
        if (result.isConfirmed) {
          props.apis
            .apiSoftDeleteApplication({ applicationId: record.applicationId })
            .then((res) => {
              swal2.fire({
                title: "Application Deleted",
                text: "Application deleted successfully !!",
                icon: "success",
                iconColor: "#BB1766",
                timer: 4000,
              });
              getData();
            });
        }
      });
  };

  const generateAgreement = (e) => {
    console.log(e);
    navigate(
      `/app/generateagreement?id=${e?.applicationId}&status=${activeKey}&path=generateagreement`
    );
  };

  const regenerateAgreement = (e) => {
    console.log(e);
    navigate(
      `/app/generateagreement?id=${e?.applicationId}&status=${activeKey}&path=regenerateagreement`
    );
  };

  const copyPresignedAgreementLink = (record) => {
    if (record.status !== "AGREEMENT") {
      swal2.fire({
        title: "Signed agreement link not found!",
        icon: "warning",
        iconColor: "#BB1766",
        timer: 4000,
      });
    } else {
      let url = record?.loanAccount?.presignedAgreementLink;
      navigator.clipboard.writeText(url);
      swal2.fire({
        title: "Copied to clipboard",
        icon: "success",
        timer: 2000,
        iconColor: "#BB1766",
      });
    }
  };

  const handleLocationHistory = (record) => {
    console.log({ record });
    if (record?.customerId) {
      let link = `/app/locationhistory?applId=${record?.applicationId}&customerId=${record?.customerId}&customerName=${record?.customerName}&frompath=loanApplications`;
      navigate(link);
    } else {
      swal2.fire({
        title: "Customer ID not found",
        icon: "error",
        iconColor: "#BB1766",
        showCancelButton: false,
        timer: 3000,
      });
    }
  };
  // ----------------------------------------------------------------
  const [show, setShow] = useState(false);
  const [assignedId, setAssignedId] = useState([]);
  const [assignedToFields, setAssignedToFields] = useState([
    {
      name: "profileId",
      label: "Underwriter Name",
      type: "select",
      options: [],
    },
    {
      name: "remarks",
      label: "Remarks",
      type: "textarea",
    },
  ]);

  const handleShow = (e) => {
    setShow(true);
  };

  const handleClose = (e) => {
    setShow(false);
    setSelectedRowKeys([]);
    setAssignedId([]);
  };

  const handleAssignedTo = (record) => {
    setAssignedId([record?.applicationId]);
    handleShow();
  };

  const handleAssignedToSubmit = (e, data) => {
    let payload = {
      underwriterId: data?.profileId,
      remarks: data?.remarks,
    };
    if (selectedRowKeys?.length > 0) {
      payload.applicationIds = selectedRowKeys;
    } else {
      payload.applicationIds = assignedId;
    }
    console.log({ data, payload });

    props.apis.apiUnderwriterReAssignApplication(payload).then((res) => {
      swal2.fire({
        title: "Loan Assigned To Underwriter Successfully",
        icon: "success",
        iconColor: "#BB1766",
        showCancelButton: false,
        timer: 3000,
      });
      handleClose();
      if (activeKey === "inprogress") {
        getApplications();
      }
      if (activeKey === "sanctioned") {
        getSanctionedApplications();
      }
      if (activeKey === "approved") {
        getApprovedApplications();
      }
    });
  };

  const getUnderwriters = () => {
    let payload = {
      role: _enum.PERSONAS.underwriter,
    };
    props.apis.apiGetEmployee(payload).then(({ data }) => {
      // console.log({ apiGetEmployee: data});
      let underWriterField = assignedToFields.find(
        (o) => o.name == "profileId"
      );
      underWriterField.options = data.options("profileId", "name");
      setAssignedToFields([...assignedToFields]);
    });
  };
  // ----------------------------------------------------------------
  // TABLE ROW SELECTION
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [notSelected, setNotSelected] = useState(true);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => {
      if (activeKey === "approved") {
        if (record?.status === "ESIGNED") {
          return {
            disabled: false,
          };
        } else {
          return {
            disabled: true,
          };
        }
      }
      // console.log({ selectedRowKeys });
    },
  };

  const handleDisbursement = () => {
    console.log({ selectedRowKeys });

    props?.apis
      ?.apiUnderWriterPreDisburseApplication(
        {
          applicationIds: [...selectedRowKeys],
        },
        {
          applicationIds: [...selectedRowKeys],
        }
      )
      .then((res) => {
        swal2.fire({
          title: "Application Disbursed Successfully !!",
          icon: "success",
          iconColor: "#BB1766",
          showCancelButton: false,
          timer: 3000,
        });
        setSelectedRowKeys([]);
        getApprovedApplications();
      });
  };

  const downloadExcel = async () => {
    let payload = {
      exportStatus: _enum.APPLICATION_ROUTE_MAP[activeKey],
    };

    let startDateValue = document.querySelector("[name='startDate']")?.value;
    let endDateValue = document.querySelector("[name='endDate']")?.value;

    if (startDateValue) {
      payload.startDate = startDateValue;
    }
    if (endDateValue) {
      payload.endDate = endDateValue;
    }

    props.apis.apiExportApplicationDetails(payload).then(async (res) => {
      // console.log({ res });
      if (res) {
        let data = await res;
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute(
          "download",
          `application_${new Date().toDate()}.xlsx`
        );
        // console.log(link);
        link.click();
      }
    });
  };

  useEffect(() => {
    selectedRowKeys.length > 0 ? setNotSelected(false) : setNotSelected(true);
  }, [selectedRowKeys]);

  // ----------------------------------------------------------------

  const handleRejectReview = (record) => {
    console.log({ record });

    swal2
      .fire({
        title:
          "Are you sure you want to reject the application?\n Please provide your remarks",
        icon: "info",
        iconColor: "#BB1766",
        html: '<div id="custom-select-container"></div>',
        showCancelButton: true,
        confirmButtonColor: "#BB1766",
        cancelButtonColor: "##D6DBE7",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        customClass: {
          htmlContainer: "rejected_html_container",
          actions: "rejected_actions",
        },
      })
      .then((result) => {
        console.log({ result });
        if (result.isConfirmed) {
          let reasonSelectValue = document.querySelector(
            "[name='appinput-reasons'].form-group"
          )?.vnode.refs.select?.state.values[0]?.key;

          let otherReasonValue =
            document.querySelector("#reasonsremarks").value;

          let payload = {};

          if (reasonSelectValue === "OTHERS") {
            payload.rejectedReason = otherReasonValue;
          } else {
            payload.rejectedReason = reasonSelectValue;
          }

          console.log({ payload }, record);

          props.apis
            .apiUnderWriterRejectApplication(payload, {
              applicationId: record?.applicationId,
            })
            .then((res) => {
              swal2.fire({
                title: "Application Rejected",
                icon: "success",
                iconColor: "#BB1766",
                showCancelButton: false,
                timer: 3000,
              });
              navigate(`/app/loanapplications?activetab=approved`);
              getData();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    let container = document.getElementById("custom-select-container");
    let root = createRoot(container);
    root.render(
      <Provider store={store}>
        <AppInput
          name="reasons"
          label="Rejected Reasons"
          type="select"
          options={_enum.REJECTED_REASONS}
          onChange={(...args) => handleRejectedReasons(...args)}
          required={true}
        ></AppInput>
        <AppInput
          id="reasonsremarks"
          name="remarks"
          label="Remarks"
          type="textarea"
          required={true}
          outerclass="d-none"
        ></AppInput>
      </Provider>
    );
  };

  const handleRejectedReasons = (val) => {
    let reason = val[0]?.key;
    console.log({ reason });
    if (reason === "OTHERS") {
      document
        .querySelector('[name="appinput-remarks"]')
        .classList.remove("d-none");
    } else {
      document
        .querySelector('[name="appinput-remarks"]')
        .classList.add("d-none");
    }
  };
  // ----------------------------------------------------------------

  const getData = (payload) => {
    // clear table data from previous request
    setTableData([]);
    if (activeKey === "pendingapplications") {
      setColumns(pendingapplicationsColumns);
      getUnassignedApplications(payload);
    } else if (activeKey === "inprogress") {
      if (!isAdmin && !isCpa) {
        setColumns(
          inprogressColumns?.filter((v) => v.dataIndex !== "underwriter")
        );
      } else {
        setColumns(inprogressColumns);
      }
      getApplications(payload);
    } else if (activeKey === "sanctioned") {
      if (!isAdmin && !isCpa) {
        setColumns(
          sanctionedColumns?.filter(
            (v) => v.dataIndex !== "underwriter" && v.dataIndex !== "kfs"
          )
        );
      } else {
        setColumns(sanctionedColumns);
      }
      getSanctionedApplications(payload);
    } else if (activeKey === "approved") {
      if (!isAdmin && !isCpa) {
        setColumns(
          sanctionedColumns?.filter(
            (v) => v.dataIndex !== "underwriter" && v.dataIndex !== "roi"
          )
        );
      } else {
        setColumns(sanctionedColumns.filter((v) => v.dataIndex !== "roi"));
      }
      getApprovedApplications(payload);
    } else if (activeKey === "rejected") {
      if (!isAdmin && !isCpa) {
        setColumns(
          rejectedapplicationsColumns?.filter(
            (v) => v.dataIndex !== "underwriter"
          )
        );
      } else {
        setColumns(rejectedapplicationsColumns);
      }
      getRejectedApplications(payload);
    }
  };

  const onSearch = (data, reset) => {
    console.log("onSearch on loan appl", data, reset);
    let defaultSearchData = Object.only(data, ["limit", "page"]);
    let payload;
    if (reset) {
      payload = {
        ...defaultSearchData,
      };
    } else {
      payload = {
        ...data,
        page: 1,
        limit: 10,
      };
    }
    setSearch(payload);
  };

  useEffect(() => {
    setColumns([]);
    setTableData([]);
    setRowcount(0);

    let payload = {
      ...search,
    };

    const str = window.location.search;
    const params = Object.fromEntries(new URLSearchParams(str));
    console.log(params);

    if (params.hasOwnProperty("status")) {
      payload.status = params?.status;
    }

    console.log({ payload, search });

    getData(payload);
  }, [activeKey, search]);

  useEffect(() => {
    if (!isCpa) {
      getUnderwriters();
    }
    let paramsActiveTab = props.urlparams.params.activetab;

    if (isAdmin) {
      if (paramsActiveTab) {
        setActiveKey(paramsActiveTab);
      } else {
        setActiveKey("pendingapplications");
        navigate(`/app/loanapplications?activetab=pendingapplications`);
      }
    } else if (isCpa) {
      if (paramsActiveTab) {
        setActiveKey(paramsActiveTab);
      } else {
        setActiveKey("rejected");
        navigate(`/app/loanapplications?activetab=rejected`);
      }
    } else {
      if (paramsActiveTab) {
        setActiveKey(paramsActiveTab);
      } else {
        setActiveKey("inprogress");
        navigate(`/app/loanapplications?activetab=inprogress`);
      }
    }
    // scroll page to top
    window.scrollTo(0, 0);
  }, []);

  const hanldeInitiateRelook = (record) => {
    swal2
      .fire({
        title: "Are you sure want to relook this case?",
        icon: "warning",
        iconColor: "#BB1766",
        showCancelButton: true,
        confirmButtonColor: "#BB1766",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
      .then((result) => {
        if (result.isConfirmed) {
          props.apis
            .apiReopenApplication({
              applicationNumber: record.applicationId,
            })
            .then((res) => {
              swal2.fire({
                title: "Application restored",
                text: "Application restored successfully !!",
                icon: "success",
                iconColor: "#BB1766",
                timer: 4000,
              });
              getRejectedApplications();
            });
        }
      });
  };

  // ------------------------------------------------------------------
  // HANDLE CHANGE PASSWORD MODAL

  const changePasswordModalRef = useRef(0);
  const [popupChangePasswordFields, setPopupChangePasswordFields] = useState(
    {}
  );
  const [changepasswordData, setChangepasswordData] = useState({});

  const [changepasswordFields, setChangepasswordFields] = useState([
    {
      label: "Old Password",
      name: "oldPassword",
      type: "password",
      customcolspan: "12",
    },
    {
      label: "New Password ",
      name: "newPassword",
      type: "password",
      customcolspan: "12",
    },
    {
      label: "Confirm Password",
      name: "confirmPassword",
      type: "password",
      customcolspan: "12",
    },
  ]);

  const openChangePasswordmodal = () => {
    changePasswordModalRef.current.click();
  };

  const closeChangePasswordmodal = () => {
    document.querySelector("#changepasswordModal #bsmodalclose").click();
    setChangepasswordData({});
    setPopupChangePasswordFields({});
  };

  const addChangepasswordData = () => {
    let fields = (changepasswordFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    // console.log("formdata: ", fields, formdata);
    setPopupChangePasswordFields(fields);
    setChangepasswordData(formdata);
    openChangePasswordmodal();
  };

  const handleChangePasswordSubmit = (e, data) => {
    console.log({ handleChangePasswordSubmit: data });
    if (data.newPassword !== data.confirmPassword) {
      swal2.fire({
        title: "Password and Confirm Password does not match",
        icon: "warning",
        iconColor: "#BB1766",
        timer: 4000,
      });
    } else {
      let payload = {
        oldPassword: data.oldPassword,
        newPassword: data.newPassword,
      };

      props.apis.apiPasswordReset(payload).then((res) => {
        console.log({ apiPasswordReset: res });
        if (res.status === 200) {
          swal2
            .fire({
              title:
                "Password changed successfully, Please re-login with new password",
              icon: "success",
              iconColor: "#BB1766",
            })
            .then((result) => {
              if (result.isConfirmed) {
                closeChangePasswordmodal();
                props?.apis?.applogout();
                props?.navigate("/open/login");
              }
            });
        }
      });
    }
  };

  useEffect(() => {
    const { emailAddress } = props?.$store?.logged;
    const { isPasswordUpdated, role } = props?.$store?.user;
    console.log({ emailAddress, isPasswordUpdated, role });

    if (!isPasswordUpdated) {
      addChangepasswordData();
    }
  }, []);

  // ----------------------
  const commonLocationHistory = {
    locationHistoryLink: [
      "pendingapplications",
      "inprogress",
      "approved",
      "sanctioned",
      "rejected",
    ].includes(activeKey),
    viewLocationHistoryAction: handleLocationHistory,
  };

  // ----- Admin Permissions Map -----
  const getAdminProps = () => {
    const baseProps = {
      viewAction: view,
      deleteAction: softDeleteApplication,
      ...commonLocationHistory,
    };

    const adminMap = {
      pendingapplications: {
        viewable: true,
        deletable: true,
        rowSelection,
      },
      inprogress: {
        viewable: true,
        editable: false,
        deletable: true,
        assignedToLink: true,
        rowSelection,
        assignedToLinkAction: handleAssignedTo,
      },
      sanctioned: {
        viewable: true,
        editable: false,
        deletable: true,
        assignedToLink: true,
        rejectReasonLink: true,
        rowSelection,
        assignedToLinkAction: handleAssignedTo,
        rejectReasonLinkAction: handleRejectReview,
      },
      approved: {
        viewable: true,
        editable: false,
        deletable: true,
        assignedToLink: true,
        rejectReasonLink: true,
        rowSelection,
        assignedToLinkAction: handleAssignedTo,
        rejectReasonLinkAction: handleRejectReview,
      },
      rejected: {
        viewable: true,
        editable: false,
        deletable: true,
        searchable: true,
        searchActionText: "Initiate Relook",
        searchAction: hanldeInitiateRelook,
      },
    };

    return {
      ...baseProps,
      ...adminMap[activeKey],
    };
  };

  // ----- UnderWriter Permissions Map -----
  const getUnderWriterProps = () => {
    const baseProps = {
      ...commonLocationHistory,
    };

    const uwMap = {
      pendingapplications: {
        viewable: false,
        editable: false,
        deletable: false,
        assignedToLink: true,
        assignedToLinkAction: handleAssignedTo,
      },
      inprogress: {
        viewable: true,
        editable: true,
        deletable: false,
        assignedToLink: true,
        rowSelection,
        viewAction: view,
        editAction: edit,
        assignedToLinkAction: handleAssignedTo,
      },
      sanctioned: {
        viewable: true,
        editable: true,
        deletable: false,
        viewAction: view,
        editAction: edit,
      },
      approved: {
        viewable: true,
        editable: false,
        deletable: false,
        agreementLink: true,
        agreementRegenerateLink: true,
        copyable: true,
        rowSelection,
        viewAction: view,
        agreementLinkAction: generateAgreement,
        agreementRegenerateLinkAction: regenerateAgreement,
        copyLinkAction: copyPresignedAgreementLink,
      },
      rejected: {
        viewable: true,
        editable: false,
        deletable: false,
        viewAction: view,
      },
    };

    return {
      ...baseProps,
      ...uwMap[activeKey],
    };
  };

  // ----- CPA Permissions -----
  const getCpaProps = () => ({
    viewable: true,
    editable: false,
    deletable: false,
    viewAction: view,
    ...commonLocationHistory,
  });

  // ----- Final Permissions Wrapper -----
  const appTablePermissionProps = (() => {
    if (isAdmin) return getAdminProps();
    if (isUnderWriter) return getUnderWriterProps();
    if (isCpa) return getCpaProps();
    return {};
  })();

  props.$setNode({
    props,
    search,
  });
  return (
    <>
      <MainPagetitle
        mainTitle="My Applications"
        parentTitle={"Home"}
        pageIcon={imagepaths.applicationCheckActiveImg}
      />
      <div className="container-fluid">
        <div className="filter_tab_container">
          {isCpa ? (
            <>
              {filterTabData
                .filter((tab) => tab.key === "rejected")
                .map((btn) => {
                  return (
                    <>
                      <button
                        type="button"
                        id={btn.key}
                        className={Object.className({
                          active: activeKey === btn.key,
                        })}
                        onClick={(...args) => handleSelect(...args, btn.key)}
                      >
                        {btn.name}
                      </button>
                    </>
                  );
                })}
            </>
          ) : (
            <>
              {filterTabData
                .filter(
                  (tab) =>
                    tab.key !== "pendingapplications" ||
                    [
                      _enum.ROUTE_PERSONAS.admin,
                      _enum.ROUTE_PERSONAS.cpa,
                    ].includes(userRole)
                )
                .map((btn) => {
                  return (
                    <>
                      <button
                        type="button"
                        id={btn.key}
                        className={Object.className({
                          active: activeKey === btn.key,
                        })}
                        onClick={(...args) => handleSelect(...args, btn.key)}
                      >
                        {btn.name}
                      </button>
                    </>
                  );
                })}
            </>
          )}
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card border-0">
              <div className="card-body p-0">
                <div className="tbl-caption-container p-0 justify-content-end">
                  <LoanApplicationSearch
                    onSearch={(...arg) => onSearch(...arg)}
                    downloadExcel={(...arg) => downloadExcel(...arg)}
                    activeKey={activeKey}
                  />
                </div>
                <AppTable
                  data={tableData}
                  columns={columns}
                  onChange={onPageChange}
                  total={rowcount}
                  reorder={true}
                  {...appTablePermissionProps}
                  loading={isFetching}
                />
              </div>
            </div>
          </div>
        </div>
        {isUnderWriter && (
          <div
            className={Object.className({
              "row bottom_container": true,
              "d-none": activeKey !== "approved",
            })}
          >
            <div className="col-12 text-end">
              <button
                className={Object.className({
                  "btn btn-primary m-3": true,
                })}
                onClick={(e) => handleDisbursement(e)}
                disabled={notSelected}
              >
                Send for Disbursement
              </button>
            </div>
          </div>
        )}
      </div>
      {/* ASSIGNED TO MODAL */}
      <Modal
        show={show}
        onHide={(...args) => handleClose(...args)}
        className="customer_application_modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Assign To</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <AppForm onSubmit={handleAssignedToSubmit}>
            {assignedToFields?.map((field, i) => (
              <AppInput {...field}></AppInput>
            ))}
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-primary-lite me-3"
                onClick={(...args) => handleClose(...args)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Assign
              </button>
            </Modal.Footer>
          </AppForm>
        </Modal.Body>
      </Modal>

      <button
        className="btn btn-sm btn-outline-secondary d-none"
        onClick={(e) => addChangepasswordData(e)}
        ref={changePasswordModalRef}
        data-bs-toggle="modal"
        data-bs-target="#changepasswordModal"
      >
        <span>Change Password</span>
      </button>

      <LeadsCenteredModal
        id="changepasswordModal"
        title="Change Password"
        submitText="Chage Password"
        hidecancelbtn={true}
        data={changepasswordData}
        fields={popupChangePasswordFields}
        onSubmit={(...args) => handleChangePasswordSubmit(...args)}
        modaltype="centeredmodal"
        onClose={() => closeChangePasswordmodal()}
      />
    </>
  );
};

export default constore(LoanApplications);
